
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Patient from '@/types/Patient';
    import { ElgaLoaders } from '@/store/types';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import api from '@/services/Api';
    import {AxiosResponse} from 'axios';
    import moment from 'moment';
    import Impfung from '@/types/Impfung';
    import PatientName from '@/components/PatientName.vue';

    @Component({
        components: {
            PatientName
        },
        computed: {
            ...mapState('patient', ['loaders', 'showAllePatientInfo', 'patientLastAnamnese']),
            ...mapState('warteliste', { wartelisteLoaders: 'loaders' }),
            ...mapGetters('authentication', ['isAllowed', 'getSystemEinstellung']),
        },
        methods: {
            ...mapActions('patient', [
                'patientDetail',
                'patientNew',
                'patientNeuMitAdresse',
                'patientNeuMitAdresseUndPlan',
                'closePatient',
                'patientDruck',
                'printEtiketten',
                'patientEtiketten',
                'patientFolgetermin',
                'setLoaders',
                'findImpfpass',
                'syncImpfpass',
                'getCardInfo',
            ]),
            ...mapMutations('patient', ['setLoadersElga', 'setDialogWarteliste', 'setDialogZurKassa']),
            ...mapActions('warteliste', ['updateWarteliste']),
            ...mapMutations('warteliste', ['setEdit']),
        },
    })
    export default class PatientOverview extends Vue {
        @Prop() patient!: Patient;

        public setLoadersElga!: (loaders: ElgaLoaders) => void;
        public syncImpfpass!: (patient: Patient) => void;
        public findImpfpass!: (patient: Patient) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public setDialogWarteliste!: (visible: boolean) => void;
        public setEdit!: (edit: boolean) => void;
        public getCardInfo!: (payload: {onlyInfo: boolean}) => void;
        public zeitraum = '';
        public patientLastAnamnese!:any;

        public mounted() {
            this.zeitraum = moment().subtract(24, 'hours').format('YYYY-MM-DD');
        }

        public onClickElga(): void {
            this.setLoadersElga({ patient: true });

            if (this.patient.bpk_gh) {
                this.syncImpfpass(this.patient);
            } else {
                this.findImpfpass(this.patient);
            }
        }

        public onClickECARD(): void {
            const zeitraum = moment().subtract(24, 'hours').format('YYYY-MM-DD');

            if (this.patient.pat_kontakt && (this.patient.pat_kontakt > zeitraum)) {
                this.getCardInfo({onlyInfo: true});
            }
        }

        public onClickWarten() {
            this.setDialogWarteliste(true);
            this.setEdit(false);
        }

        @Watch('patient.patientengruppe_id')
        public onChangePatientenGruppe() {
            if (this.patient && this.getSystemEinstellung('muw').isEnabled() && this.patient.patientengruppe_id) {
                api.post('verwaltung/patientengruppen/get', {patientengruppe_id: this.patient.patientengruppe_id})
                    .then((response: AxiosResponse) => {
                        this.patient.patientengruppe_name = response.data.body.patientengruppe;
                    })
                    .catch(console.error);
            }
        }

        @Watch('patient.versicherung_id')
        public onChangePatientenVersicherung() {
            if (this.patient) {
                api.post('ivs/patienten/getpatientenkontakt', {patnr: this.patient.patnr})
                    .then((response: AxiosResponse) => {
                        this.patient.versicherung_name = response.data.body.patient.versicherung_name;
                    })
                    .catch(console.error);
            }
        }

        @Watch('patient.patnr')
        public getPatientKontaktTime() {
            if (this.patient) {
                api.post('ivs/patienten/getpatientenkontakt', {patnr: this.patient.patnr})
                    .then((response: AxiosResponse) => {
                        this.patient.pat_kontakt = response.data.body.patient.pat_kontakt;
                    })
                    .catch(console.error);
            }
        }

        public get isThereValidKontakt(): boolean {
            if (!this.patient) {
                return false;
            } else if (this.patient) {
                if (!this.patient.pat_kontakt) {
                    return false;
                } else if (this.patient.pat_kontakt && (this.patient.pat_kontakt > this.zeitraum)) {
                    return true;
                }
            }
            return false;
        }

        /*        @Watch('patient')
        public getLastAnamnese() {
            if (this.patient) {
                api.post('ivs/patimpfungen/checkanamnese', {patnr: this.patient.patnr})
                    .then((response: AxiosResponse) => {
                        if (response.data.body.patimpfung_id) {
                            this.patientAnamnese = new Impfung(response.data.body);
                            console.log(this.patientAnamnese);
                        }
                    })
                    .catch(console.error);
            }
        }*/
    }
